import React from "react";
import Modal from 'react-modal';
import { Progress } from "@material-tailwind/react";
import './LoadingPane.css';
import useGlobalState from "../../../context/GlobalState";

interface LoadingPaneProps {
    message?: string;
}

const LoadingPane = ({
    message = "Cargando...",
}: LoadingPaneProps) => {

    const customStyles = {
        content: {
            margin: 'auto',
            width: 'Fit-content',
            height: 'Fit-content',
            borderRadius: '15px',
        },
    };

    const { loadingMessage,isLoading, uploadProgress } = useGlobalState();


    return !window.location.pathname.includes('login') ? (
        <Modal
            isOpen={isLoading}
            ariaHideApp={false}
            style={customStyles}
            contentLabel="Panel De Carga"
        >
            <div className="LoaderModal">
                <div aria-label="Orange and tan hamster running in a metal wheel" role="img" className="wheel-and-hamster">
                    <div className="wheel"></div>
                    <div className="hamster">
                        <div className="hamster__body">
                            <div className="hamster__head">
                                <div className="hamster__ear"></div>
                                <div className="hamster__eye"></div>
                                <div className="hamster__nose"></div>
                            </div>
                            <div className="hamster__limb hamster__limb--fr"></div>
                            <div className="hamster__limb hamster__limb--fl"></div>
                            <div className="hamster__limb hamster__limb--br"></div>
                            <div className="hamster__limb hamster__limb--bl"></div>
                            <div className="hamster__tail"></div>
                        </div>
                    </div>
                    <div className="spoke"></div>
                </div>
                {uploadProgress === undefined ? (
                    loadingMessage || message && <p>{ loadingMessage || message }</p>
                ) : (
                    <div className="flex w-full flex-col gap-4">
                        { uploadProgress >= 100 ?
                        <p>Ya casi esta listo!!</p> : 
                        <>
                            <p>Subiendo Archivo...</p>
                            <Progress placeholder={null} value={uploadProgress} color="green" />
                        </>}
                    </div>
                )}
            </div>
        </Modal>
    ) : (<></>);
};

export default LoadingPane;